// Protocol used by the Event Logs listener to share event logs files
export enum ListenerFileSharingMode {
  smb = 'smb',
  sysvol = 'sysvol'
}
